import { motion } from "motion/react";
import { Zap } from "lucide-react";

import FlashDealsCountdown from "@/theme2/components/flashDeals/FlashDealsCountdown";

export default function FlashDealsHero({ hero }) {
  return (
    <section className="relative isolate overflow-hidden rounded-[2rem] bg-gradient-to-br from-orange-500 via-orange-600 to-red-600 px-5 py-10 text-white shadow-2xl shadow-orange-500/20 sm:px-8 sm:py-14 lg:px-14 lg:py-16">
      <div className="absolute -right-24 -top-24 size-80 rounded-full bg-white/15 blur-3xl" />
      <div className="absolute -bottom-28 -left-24 size-72 rounded-full bg-yellow-300/15 blur-3xl" />

      <motion.div
        animate={{ y: [0, -8, 0] }}
        transition={{
          duration: 7,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="absolute right-[10%] top-[15%] hidden size-24 rotate-12 rounded-[2rem] border border-white/20 bg-white/10 backdrop-blur-xl lg:block"
      />

      <div className="relative grid gap-10 lg:grid-cols-[1fr_0.85fr] lg:items-center">
        <motion.div
          initial={{ opacity: 0, x: -28 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.65, ease: "easeOut" }}
        >
          <p className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs font-black uppercase tracking-[0.24em] backdrop-blur-xl">
            <Zap className="size-4 fill-current" />
            {hero.eyebrow}
          </p>

          <h1 className="mt-6 text-5xl font-black uppercase leading-[0.88] tracking-[-0.06em] sm:text-7xl lg:text-8xl">
            {hero.title}
          </h1>

          <p className="mt-6 max-w-xl text-sm leading-7 text-white/75 sm:text-base sm:leading-8">
            {hero.description}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 28 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.65, delay: 0.08 }}
          className="rounded-[1.75rem] border border-white/20 bg-black/15 p-5 backdrop-blur-xl sm:p-7"
        >
          <p className="text-xs font-black uppercase tracking-[0.28em] text-white/60">
            Campaign Ends In
          </p>

          <div className="mt-5">
            <FlashDealsCountdown targetDate={hero.endsAt} />
          </div>
        </motion.div>
      </div>
    </section>
  );
}